import React from 'react';
export const LegendBetaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={18}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.508 13.874V4.984C8.508 4.9 8.522 4.858 8.592 4.844C9.082 4.83 10.454 4.802 11.448 4.802C14.43 4.802 14.92 6.328 14.92 7.252C14.92 8.204 14.416 8.778 14.066 9.03C14.584 9.296 15.368 9.898 15.368 11.186C15.368 12.894 13.884 14.028 11.476 14.028C10.118 14.028 9.124 14.014 8.606 14C8.536 13.986 8.508 13.944 8.508 13.874ZM10.412 10.08V12.376C10.706 12.39 11.014 12.404 11.434 12.404C12.638 12.418 13.352 12.026 13.352 11.214C13.352 10.738 13.156 10.332 12.498 10.164C12.274 10.108 11.966 10.08 11.616 10.08H10.412ZM10.412 6.468V8.414H11.364C11.84 8.414 12.4 8.456 12.61 8.484C12.862 8.26 13.03 7.994 13.03 7.532C13.03 6.818 12.498 6.44 11.434 6.44C11 6.44 10.72 6.454 10.412 6.468Z"
      fill="#147AF3"
    />
  </svg>
);
